import { render, staticRenderFns } from "./model_3d.vue?vue&type=template&id=24918158&scoped=true"
import script from "./model_3d.vue?vue&type=script&lang=js"
export * from "./model_3d.vue?vue&type=script&lang=js"
import style0 from "./model_3d.vue?vue&type=style&index=0&id=24918158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24918158",
  null
  
)

export default component.exports